import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=5d9a82e4&scoped=true"
import script from "./CopyInput.vue?vue&type=script&lang=js"
export * from "./CopyInput.vue?vue&type=script&lang=js"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=5d9a82e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a82e4",
  null
  
)

export default component.exports